import { useState } from "react";

import { Button } from "@/components/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
  DialogHeader,
} from "@/components/dialog";
import { FieldError, Label, TextArea, TextField } from "@/components/field";
import { Modal } from "@/components/modal";

const MAX_PROMPT_LENGTH = 2000;

type GenerateNewAdsDialogProps = {
  errorMessage: null | string;
  isGenerating: boolean;
  isOpen: boolean;
  onGenerate: (prompt: string) => void;
  onOpenChange: (isOpen: boolean) => void;
};

export function GenerateNewAdsDialog({
  errorMessage,
  isGenerating,
  isOpen,
  onGenerate,
  onOpenChange,
}: GenerateNewAdsDialogProps) {
  const [prompt, setPrompt] = useState("");
  const trimmedPrompt = prompt.trim();

  return (
    <Modal isDismissable isOpen={isOpen} onOpenChange={onOpenChange}>
      <Dialog>
        <DialogCloseButton />
        <DialogHeader>Generate new ads</DialogHeader>
        <DialogBody>
          <TextField
            isInvalid={Boolean(errorMessage)}
            maxLength={MAX_PROMPT_LENGTH}
            onChange={setPrompt}
            value={prompt}
          >
            <Label>What should the new ads be about?</Label>
            <TextArea className="resize-none" rows={5} />
            <FieldError>{errorMessage}</FieldError>
          </TextField>
        </DialogBody>
        <DialogFooter>
          <Button
            color="gray"
            onPress={() => onOpenChange(false)}
            size="lg"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            isDisabled={!trimmedPrompt}
            isLoading={isGenerating}
            onPress={() => onGenerate(trimmedPrompt)}
            size="lg"
            variant="primary"
          >
            Generate
          </Button>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
